var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "https://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 1.502 4.507 0l2.835 5.67-4.55 2.274.027.083c1.065 3.2 3.177 5.311 6.377 6.377l.082.026 2.275-4.549 5.67 2.835-1.502 4.507H15C5.24 17.223.13 12.237.002 2.596zm12.447 11.062-1.178 2.357.291.05q1.015.161 2.14.22l.582.02.495-1.482zM3.493 2.444 2.01 2.94v.014q.04 1.44.242 2.709l.049.29 2.357-1.178-1.165-2.33z"
})));
export default SvgPhone;